import React, { FC, useCallback, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import classes from '../../asset/css/subscription-detail/switch-button.module.scss';
import '../../asset/css/animations.css';
import * as crypto from 'crypto';
import LoadingImg from '../../asset/images/on_loop.gif';

export const SwitchOnButton: FC<{
  animating: boolean;
  loading: boolean;
  btnClickFunc: () => void;
  animateCompleteFunc: () => void;
}> = ({ animating, loading, btnClickFunc, animateCompleteFunc }) => {
  const [animations, setAnimations] = useState<{
    slide: boolean;
    scaleUp: boolean;
    loading: boolean;
    complete: boolean;
  }>({
    slide: false,
    scaleUp: false,
    loading: false,
    complete: false,
  });

  const button = useRef<HTMLButtonElement>(null);

  const btnClickHandler = useCallback(() => {
    if (animating || loading) return;

    btnClickFunc();

    setAnimations({
      ...animations,
      slide: true,
    });
  }, [animating, animations, btnClickFunc, loading]);

  const checkLoadingHandler = useCallback(() => {
    const checkLoading = () => {
      setTimeout(() => {
        if (button!.current!.dataset.loading === 'true') {
          checkLoading();
          return;
        }

        setAnimations({
          ...animations,
          loading: true,
        });
      }, 100);
    };

    checkLoading();
  }, [animations]);

  return (
    <button
      className={classes.switchBg}
      onClick={btnClickHandler}
      ref={button}
      data-loading={loading}
    >
      <div className={classes.switchOnChangedBg} hidden={!animations.loading}/>
      <div
        className={`${classes.switch} ${classes.switchOffBg} ${classes.switchLeft}`}
        hidden={animations.slide || animations.loading || animations.complete}
      />
      <CSSTransition
        in={animations.slide}
        unmountOnExit
        timeout={200}
        classNames="switch-on-slide"
        onEntered={() => {
          setAnimations({
            ...animations,
            scaleUp: true,
          });
        }}
      >
        <div className={`${classes.switch} ${classes.switchLeft} ${classes.switchOffBg}`} hidden={animations.loading} />
      </CSSTransition>
      <CSSTransition
        in={animations.scaleUp}
        unmountOnExit
        timeout={200}
        classNames="switch-on-scale-up"
        onEntered={checkLoadingHandler}
      >
        <div
          className={`${classes.switch} ${classes.switchRight} ${classes.switchLoadingBg} ${classes.switchOpacityZero}`}
          hidden={animations.loading}
        />
      </CSSTransition>
      <div className={`${classes.switch} ${classes.switchRight} ${classes.switchOnBg}`} hidden={!animations.loading} />
      <CSSTransition
        in={animations.loading}
        timeout={200}
        unmountOnExit
        classNames="switch-on-complete"
        onEntered={() => {
          setAnimations({
            ...animations,
            complete: true,
          });

          setTimeout(() => {
            animateCompleteFunc();
          }, 200);
        }}
      >
        <div
          className={`${classes.switch} ${classes.switchRight} ${classes.switchLoadingBg}`}
        />
      </CSSTransition>
    </button>
  );
};
